import './header.scss';
import logo from '../../img/logo.png';

export default function Header({ title, subtitle }) {
	const isProd = !window.location.search.includes('builder') && !window.builder;
	let isOnline = window.location.protocol.includes('http') && window.location.hostname !== 'localhost';

	if (!isProd) {
		return null;
	}
	let gif_url = window.global_data?.top?.gifUrl;
	if (!gif_url) {
		gif_url = process.env.PUBLIC_URL + "/animation.gif";
	}

	const url_route = new URLSearchParams(window.location.search).get('backUrl') || document.referrer;

	return (
		<div className={`page-header py-3 ${window.global_data?.top?.themeColor}`}>
			<div className="container">
				{isOnline ? (
					<a href="/">
						<img style={{ maxWidth: 180 }} src={logo} alt="Pilietiskumo mokykla" className="mb-2" />
					</a>
				) : (
					<img style={{ maxWidth: 180 }} src={logo} alt="Pilietiskumo mokykla" className="mb-2" />
				)}
				<div className="page-header-icon">
					{url_route && (
						<div className="my-4">
							<Back url={url_route} />
						</div>
					)}
					<img className="header-icon" src={gif_url} alt="animacija" style={{ width: 150 }} />
				</div>
				<h1>{title}</h1>
				<h4>{subtitle}</h4>
			</div>
		</div>
	)
}
function Back({ url }) {
	const btn = {
		color: '#163C60',
		fontWeight: '600',
		display: 'inline-flex',
		alignItems: 'center',
		padding: '.5rem',
		border: 'none',
		background: 'transparent'
	}
	return (
		<a href={url} style={btn}>
			<svg className="me-3" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M3.828 7.00066H16V9.00066H3.828L9.192 14.3647L7.778 15.7787L0 8.00066L7.778 0.222656L9.192 1.63666L3.828 7.00066Z" fill="currentColor" />
			</svg>
			Grįžti
		</a>
	)
}